import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installTabletApi } from './camera/tabletApi';
import { carryLegacyStores } from './lib/storeCarry';
import './index.css';
import { installErrorReporting } from './lib/errorReporting';
import { requestPersistentStorage } from './lib/persistentStorage';

// Production only: the dev server's console is watched by the e2e guard and read by the developer.
if (import.meta.env.PROD) installErrorReporting();

void requestPersistentStorage();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const root = ReactDOM.createRoot(rootElement);
const notice = (text: string) =>
  root.render(<output className="block p-6 text-center">{text}</output>);

// The app opens no store until older databases are carried over: a store it opened first would
// stand where the carry copies to. A failed carry keeps the old databases and shows no app.
installTabletApi()
  .catch((err: unknown) => console.error('[tablet] shell setup failed:', err))
  .then(() =>
    carryLegacyStores(indexedDB, {
      onBlocked: () => notice('Close other RosaHouse tabs to finish updating.'),
    }),
  )
  .then(
    () =>
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      ),
    (err: unknown) => {
      console.error('[stores] carrying local data to the new store names failed:', err);
      notice('RosaHouse could not update the data saved on this device. Reload to try again.');
    },
  );
